import './App.css';
import JoelBumper from './media/IMG_5159.jpg';
import Gump from './media/182A8816-02DE-4D0E-8787-B1EEDB1273B7.MOV';
import LowQGump from './media/41CDDE45-801C-42C5-A861-1FA503DA1B88.MOV';
import Lick from './media/8CE77F9D-D326-4B2F-9F3A-DC025546500A.MOV';
import smth from './media/DE1E3CBB-BEB9-4483-A50A-47FCF2E5B10F.MOV';
import {useState} from 'react';
import ReactPlayer from 'react-player'


const sources = [
  {
    src: JoelBumper,
    text: "Joel \"Bumper\" Reeves in his natural state",
    image: true
  },
  {
    src: Gump,
    text: "Langston Gumption",
  },
  {
    src: LowQGump,
    text: "Langston Gumption (4k version)",
  },
  {
    src: Lick,
    text: "Yeah doc",
  },
  {
    src: smth,
    text: "Liam moving different",
  },
]
function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Media/>
      </header>
    </div>
  );
}
function Media() {
  const [index, setIndex] = useState(0)
  const current = sources[index];
  if(current.image){
    return(
      <div>
        <p>Exhibit {index + 1}: {current.text}</p>
        <div>
          <button onClick={() => {
            console.log((sources.length + index - 1) % sources.length);
            setIndex((sources.length + index - 1) % sources.length)
          }}>Previous</button>
          <button onClick={() =>{
            setIndex((index + 1) % sources.length)
          }}>Next</button>
        </div>
        <img src={current.src} alt={current.text} height={400}/>
      </div>
    );
  }else{
    return(
      <div>
        <p>Exhibit {index + 1}: {current.text}</p>
        <div>
          <button onClick={() => {
            console.log((sources.length + index - 1) % sources.length);
            setIndex(((sources.length + index - 1)) % sources.length)
          }}>Previous</button>
          <button onClick={() =>{
            setIndex((index + 1) % sources.length)
          }}>Next</button>
        </div>
        <ReactPlayer src={current.src} playing={true} loop={true} playsInline/>
      </div>
    )
  }
}

export default App;
